module.exports = __webpack_public_path__ + "img/3.bd932b0f.jpg";